const onlyNumbers = (str) => {
  const regex = /[^0-9]/g;
  const numbersOnly = str.replace(regex, "");
  return numbersOnly;
};

export default onlyNumbers;
